import React from 'react';
import SubjectForm from '../SubjectForm/SubjectForm';

const AddSubjectForm: React.FC = () => {
    return <SubjectForm mode="add" />;
};

export default AddSubjectForm;
